<template>
	<div>
		<b-card>
			<template #header>
				<div class="card-header-title mt-1"><h5>{{ $t('air_cafe.product') }}</h5></div>
				<div class="card-header-actions">
					<b-input-group>
						<template #append>
							<b-input-group-text><strong class="fa fa-search"/></b-input-group-text>
							<b-button @click="createForm" variant="outline-primary" size="sm" class="mr-2 ml-3" style="font-size: 14px"><i class="fa fa-plus-circle"/></b-button>
						</template>
						<b-form-input v-model="search"/>
					</b-input-group>
				</div>
			</template>
			<b-overlay :show="loading" rounded="sm">
				<table class="table table-bordered table-hover">
					<thead>
						<tr>
							<th class="text-center">{{ '№' }}</th>
							<th class="text-center">{{ $t('restaurant.photo') }}</th>
							<th class="text-center">{{ $t('air_cafe.category') }}</th>
							<th class="text-center">{{ $t('air_cafe.name_uz') }}</th>
							<th class="text-center">{{ $t('air_cafe.name_ru') }}</th>
							<th class="text-center">{{ $t('air_cafe.name_en') }}</th>
							<th class="text-center">{{ $t('incomes.create.price') }}</th>
							<th class="text-center">{{ $t('sale.status') }}</th>
							<th class="text-center">{{ $t('goods.actions') }}</th>
						</tr>
					</thead>
					<tbody v-if="items.length > 0">
						<tr v-for="(item, index) in items" :key="`group-${index}`">
							<td class="text-center pt-3">{{ index + 1 }}</td>
							<td v-if="item.photoId" class="text-center" @click="uploadModal(item, index)" style="width: 10%">
								<img style="width: 70px" :src="imageUrl + item.photoId" :alt="`photos-${index}`">
							</td>
							<td v-else class="text-center" @click="uploadModal(item, index)" style="width: 10%">
								<img style="width: 70px" src="../../assets/item.png" :alt="`photos1-${index}`">
							</td>
							<td class="text-center pt-3">{{ getCategoryName(item.categoryId) }}</td>
							<td class="text-center pt-3">{{ item.nameUz }}</td>
							<td class="text-center pt-3">{{ item.nameRu }}</td>
							<td class="text-center pt-3">{{ item.nameEn }}</td>
							<td class="text-center pt-3">{{ item.prices }}</td>
							<td class="text-center pt-3"><b-checkbox v-model="item.status" @change="changeStatus(item)" switch/></td>
							<td class="text-center pt-2" style="width: 10%">
								<b-button @click="editForm(item)" variant="outline-primary" size="sm" class="fa fa-pencil"/>
							</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td class="text-center p-3" colspan="9">{{ $t('empty') }}</td>
						</tr>
					</tbody>
				</table>
				<nav class="text-center mt-2">
					<b-pagination-new background :total="total" layout="prev, pager, next" :page-size="payload.limit" :current-page.sync="payload.page"/>
				</nav>
			</b-overlay>
		</b-card>

		<!--		Image - upload		-->
		<b-modal v-model="fileUploadModal" :title="form.name" size="sm" centered hide-footer>
			<b-container>
				<b-row>
					<b-col v-if="form.photoId" class="mb-2 image-wrapper">
						<i @click.stop="deletePhoto(form)" class="fa fa-close"></i>
						<img class="img-fluid w-100 img-thumbnail mb-2" :src="imageUrl + form.photoId">
					</b-col>
					<b-col v-else>
						<div class="upload-wrapper" size="sm" variant="primary">
							<i class="fa fa-plus"></i>
							<input type="file" @input="upload">
						</div>
						<b-spinner class="ml-2" v-if="loading" small></b-spinner>
					</b-col>
				</b-row>
			</b-container>
		</b-modal>

		<!--		Create / Edit		-->
		<b-modal v-model="createModal" :title="create ? $t('incomes.create.create') : $t('booking.edit')" centered no-close-on-backdrop hide-footer>
			<b-row>
				<b-col>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('air_cafe.category') }}</strong></b-input-group-text>
						</template>
						<b-form-select v-model="form.categoryId" :options="categories" value-field="id" text-field="nameRu"/>
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('air_cafe.name_uz') }}</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.nameUz"/>
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('air_cafe.name_ru') }}</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.nameRu"/>
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('air_cafe.name_en') }}</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.nameEn"/>
					</b-input-group>
					<b-input-group class="mt-3">
						<template #prepend>
							<b-input-group-text><strong>{{ $t('incomes.create.price') }} €</strong></b-input-group-text>
						</template>
						<b-form-input v-model="form.price" type="number"/>
					</b-input-group>
				</b-col>
			</b-row>
			<hr>
			<div class="card-header-actions">
				<b-button @click="createModal =  false" variant="outline-danger" class="mr-3" size="sm">{{ $t('cancel') }}</b-button>
				<b-button @click="save" variant="success" size="sm">{{ $t('save') }}</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ProductService from "./service/product.service";
import { BOverlay } from 'bootstrapVue2';
import { Pagination } from 'element-ui'
import AirCafeCategoryService from "./service/category.service";
import AirCafeProductService from "./service/product.service";

export default {
	name: "product",
	components: {Multiselect, BOverlay,"b-pagination-new":Pagination},
	data() {
		return {
			items: [],
			total: 0,
			search: '',
			payload: {
				page: 1,
				limit: 20
			},
			create: true,
			createModal: false,
			form: {},
			categories: [],
			loadingItem: false,
			loading: false,
			fileUploadModal: false,
			whItems: []
		}
	},
	computed: {
		imageUrl() {
			return process.env.VUE_APP_ROOT_API + '/item/photo/'
		}
	},
	methods: {
		getCategoryName(id) {
			let name = ''
			this.categories.forEach(c => {
				if (c.id===id)
					name = c.nameRu
			})
			return name
		},
		uploadModal(item) {
			this.form = Object.assign({}, item)
			this.fileUploadModal = true
		},
		createForm() {
			this.create = true
			this.form = {}
			this.form.categoryId = null
			this.form.photoId = null
			this.form.status = true
			this.form.nameUz = ''
			this.form.nameRu = ''
			this.form.nameEn = ''
			this.form.price = ''
			this.createModal = true
		},
		editForm(item) {
			this.create = false
			this.form = Object.assign({}, item)
			this.createModal = true
		},
		async getList() {
			this.loading = true
			await AirCafeProductService.list(this.search, this.payload	).then(res => {
				this.items = res.data.items
				this.total = res.data.total
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async getCategories() {
			this.loading = true
			await AirCafeCategoryService.list('').then(res => {
				this.categories = res.data
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async upload($event) {
			this.loading = true;
			const fileList = $event.target.files;
			const file = fileList[0];
			const form = new FormData();
			form.append('upload', file, file.name);
			await AirCafeProductService.createPhoto(this.form.id, form).then(res => {
				this.fileUploadModal = false
				this.getList();
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async deletePhoto(item) {
			await AirCafeProductService.deletePhoto(item.id, item.photoId).then(res => {
				this.getList();
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async changeStatus(item) {
			this.loading = true
			item.status = !item.status
			await AirCafeProductService.changeStatus(item).then(res => {
				this.$vs.notify({
					title: 'Success',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
				this.getList();
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}).finally(f => {
				this.loading = false
			})
		},
		async save() {
			if (this.form.categoryId&&this.form.nameUz!==''&&this.form.nameRu!==''&&this.form.nameEn!==''&&this.form.price!=='') {
				this.loading = true
				if (this.create) {
					await AirCafeProductService.create(this.form).then(res => {
						this.createModal = false
						this.getList();
						this.$vs.notify({
							title: 'Успешно сохранено',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}).finally(f => {
						this.loading = false
					})
				} else {
					await AirCafeProductService.update(this.form).then(res => {
						this.createModal = false
						this.getList();
						this.$vs.notify({
							title: 'Успешно сохранено',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}).finally(f => {
						this.loading = false
					})
				}
			} else {
				this.$vs.notify({
					title: 'Заполните все обязательные поля',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		}
	},
	watch: {
		'search': {
			handler(e) {
				this.getList();
			}
		},
		'payload.page': {
			handler(e) {
				this.getList();
			}
		}
	},
	created() {
		this.getCategories();
		this.getList();
	}
}
</script>

<style scoped lang="scss">
.upload-wrapper{
	position: relative;
	overflow: hidden;
	border: 2px solid #e1e1e1;
	height: 200px;
	text-align: center;
}
.upload-wrapper i.fa{
	position: absolute;
	color: #e1e1e1;
	font-size: 50px;
	left: calc(50% - 25px);
	top: calc(50% - 25px)
}
.upload-wrapper input{
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	opacity: 0;
}
.image-wrapper{
	position: relative;
	cursor: pointer;
}
.image-wrapper i.fa{
	position: absolute;
	right: 15px;
	color: #fff;
	top: 0;
	padding: 5px;
	border: 5px solid #08772f;
	background: #4dbd74;
	&.fa-close {
		border: .5px solid red;
		background: lightcoral;
	}
}
</style>
